import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=94de90a4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=94de90a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94de90a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94de90a4')) {
      api.createRecord('94de90a4', component.options)
    } else {
      api.reload('94de90a4', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=94de90a4&scoped=true", function () {
      api.rerender('94de90a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/marketing_place/product/Index.vue"
export default component.exports